export default from './Stats.jsx';



// WEBPACK FOOTER //
// ./src/pages/stats/index.js